import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SavePeopleService {
  
  firstName: any;
  lastName: any;
  userDob: any;
  gender: any;
  sexuality: any;
  email: any;
  city: any;
  languages: any;
  interests: any;
  about: any;
  createdAt:any;
  role: any;
  editUser: boolean = false;
  constructor() {
    this.resetForm()
  }

  resetForm(){
    this.firstName = ""
    this.lastName = ""
    this.userDob = ""
    this.gender = ""
    this.sexuality = ""
    this.email = ""
    this.city = ""
    this.languages = []
    this.interests = []
    this.about = ""
    this.editUser = false;
  }
}
